import React from 'react';
import Delete from '../delete/index.tsx';
import AddDialog from './add/index.tsx';
import EditDialog from './edit/index.tsx';

export default function ModalsView() {
	return (
		<div>
			<AddDialog />
			<EditDialog />
			<Delete />
		</div>
	);
}
